<div class="bottom-sheet" [class.open]="isOpenState">
  <!-- Seta de abrir/fechar -->
  <span [ngClass]="{'rotate-arrow': isOpenState}" (click)="toggleSheet()"
    class="fds-icon fds-icon--16 fds-font--ford-icons__chevron-down">
  </span>

  <!-- Conteúdo do Bottom Sheet -->
  <div class="sheet-content">
    <ng-content />
  </div>
</div>
@if (isOpenState) {
  <button class="overlay" (click)="toggleSheet()"></button>
}
